































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';

const StaffAction = namespace('desk/staff').Action;
const StaffGetter = namespace('desk/staff').Getter;

const CommGetter = namespace('desk/comm').Getter;

export interface TargetEditType {
  // 编辑结构类型
  unit_price: number | null; // 单价
  user_id: number[]; // 用户ids
}

@Component({
  components: {
    AcgnPop,
  },
})

/**
 * 修改价格
 */
export default class AcgnPriceEdit extends Vue {
  public name: string = 'AcgnPriceEdit';

  @Prop({ type: Object, default: {} }) private data: TargetEditType; // 数据
  @Prop({ type: Boolean, default: false }) private visible: boolean; // 控制dialog显示

  @StaffAction private setUserPrice: any; // 设定员工价格

  @StaffGetter private loadings: any; // 章节loading
  @CommGetter private attributeData: any; // 公共类型

  private formData: TargetEditType = {
    unit_price: 0,
    user_id: [], // 用户id
  };
  private editTypes: any = {
    1: '设定单价',
    2: '修改单价',
  };

  private get isEdit() {
    return [1, 2].includes((this.data as any).type);
  }
  private get title() {
    return this.editTypes[(this.data as any).type];
  }
  private get show() {
    return this.visible;
  }
  private set show(v) {
    this.$emit('update:visible', v);
  }
  // 获取表单验证规则
  private get rules() {
    const rules = {
      unit_price: [
        { required: true, message: '请输入价格', trigger: 'change' },
      ],
    };
    return rules;
  }

  private async created() {
    this.formData = { ...this.formData, ...(this.data as any).data };
  }

  // 收费设置提交
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const postData = complexClone(this.formData);
        await this.setUserPrice(postData);
        this.$emit('change');
        this.$message.success('保存成功');
        this.show = false;
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }

  // 取消
  private close() {
    this.show = false;
  }
}
